import { render } from "./CompanyLocationsView.vue?vue&type=template&id=22289c30&scoped=true"
import script from "./CompanyLocationsView.vue?vue&type=script&lang=js"
export * from "./CompanyLocationsView.vue?vue&type=script&lang=js"

import "./CompanyLocationsView.vue?vue&type=style&index=0&id=22289c30&lang=scss&scoped=true"

import exportComponent from "/Users/mmessick/Sites/kiosk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22289c30"]])

export default __exports__